import CustomTimePicker from 'Components/CustomTimePicker'
import type { Validity } from 'Services/ProductManagement/Features/Product/types'
import { timeStringToDate } from 'Util/formatters'
import { FormControl } from '@mui/material'
import { t } from 'ttag'

interface ActivePeriodTimePickerProps {
  activePeriod: Validity
  handleTimePickerChange: (value: Date | null, name: string) => void
  isRequired?: boolean
}

export default function ActivePeriodTimePicker({
  activePeriod,
  handleTimePickerChange,
  isRequired = false
}: Readonly<ActivePeriodTimePickerProps>) {
  return (
    <>
      <FormControl sx={{ width: 200, mr: 3 }} size="small" required>
        <CustomTimePicker
          value={
            activePeriod?.time_of_day_from ? timeStringToDate(activePeriod?.time_of_day_from) : null
          }
          onChange={handleTimePickerChange}
          name="time_of_day_from"
          dateToCompare={
            activePeriod?.time_of_day_until
              ? timeStringToDate(activePeriod?.time_of_day_until)
              : null
          }
          dateToCompareFieldName="time_of_day_until"
          isStartDate={true}
          label={t`Valid from`}
          isRequired={isRequired}
        />
      </FormControl>
      <FormControl sx={{ width: 200, mr: 3 }} size="small">
        <CustomTimePicker
          value={
            activePeriod?.time_of_day_until
              ? timeStringToDate(activePeriod?.time_of_day_until)
              : null
          }
          onChange={handleTimePickerChange}
          name="time_of_day_until"
          dateToCompare={
            activePeriod?.time_of_day_from ? timeStringToDate(activePeriod?.time_of_day_from) : null
          }
          dateToCompareFieldName="time_of_day_from"
          isStartDate={false}
          label={t`Valid until`}
          isRequired={isRequired}
        />
      </FormControl>
    </>
  )
}
